<template>
    <Layout>
        <PageHeader :title="title" :items="items"></PageHeader>
        <div class="row" id="series">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <div class="form-inline navbar-search">
                    <div class="input-group">
                      <input v-on:keyup="search" name="title" class="form-control bg-light border-0 small"
                        placeholder="Search Title" aria-label="Search" aria-describedby="basic-addon2" value=""
                        v-model="filter" />
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="searchFor">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <b-table
                  :items="tableData.doctors"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive
                  class="table-bordered table-hover"
                >
                  <template v-slot:cell(fname)="row">
                    {{ row.item.fname }} {{ row.item.lname }}
                  </template>
                  
                  <template v-can="'wow-doctor-add-token'" v-slot:cell(token)="row">
                    <div>
                      <!-- Editing mode -->
                      <div v-if="editedRowId === row.item._id">
                        <div class="input-group" style="max-width: 200px;">
                          <input
                            type="number"
                            v-model.number="addTokens"
                            placeholder="Add tokens"
                            class="form-control"
                          />
                          <input
                            type="number"
                            :value="existingTokens + addTokens"
                            readonly
                            class="form-control"
                          />
                          <button class="btn btn-success" @click="saveTokens(row.item._id)">Save</button>
                        </div>
                      </div>
                      <div v-else class="token-box">
                        <p class="token-value">
                          <span class="coin">🪙</span>
                          {{ row.item.token }}
                        </p>

                        <button class="token-add-btn" @click.stop="enableTokenEdit(row.item)">
                          [+]
                        </button>
                      </div>
                    </div>
                  </template>

                  <template v-can="'wow-doctor-add-credit'" v-slot:cell(e_wallet)="row">
                    <div>

                      <!-- EDIT MODE -->
                      <div v-if="editedCreditRowId === row.item._id">
                        <div class="input-group" style="max-width: 200px;">

                          <input
                            type="number"
                            v-model.number="addCredits"
                            placeholder="Add Credits"
                            class="form-control"
                          />

                          <input
                            type="number"
                            :value="existingCredits + addCredits"
                            readonly
                            class="form-control"
                          />

                          <button
                            class="btn btn-success"
                            @click="saveCredits(row.item._id)"
                          >
                            Save
                          </button>

                        </div>
                      </div>

                      <!-- VIEW MODE -->
                      <div v-else class="token-box">

                        <p class="token-value">
                          <span class="coin">🪙</span>
                          {{ row.item.e_wallet }}
                        </p>

                        <button
                          class="token-add-btn"
                          @click.stop="enableCreditEdit(row.item)"
                        >
                          [+]
                        </button>

                      </div>

                    </div>
                  </template>
                  <template v-can="'wow-doctor-credit-history'" v-slot:cell(transaction)="row">
                    <div>
                      <router-link
                        :to="{
                          name: 'wow-doctor-credit-history',
                          params: { id: row.item._id }
                        }"
                      >
                        <b-button variant="outline-primary" class="btn-sm m-1">
                          Show Credits Details
                        </b-button>
                      </router-link>
                      <router-link
                        :to="{
                          name: 'wow-doctor-token-history',
                          params: { id: row.item._id }
                        }"
                      >
                        <b-button variant="outline-primary" class="btn-sm m-1">
                          Show Tokens Details
                        </b-button>
                      </router-link>
                    </div>
                  </template>
                </b-table>
              </div>
              <template v-if="tableData.last_page > 1">
                <div class="data_paginate">
                  
                  <div class="d-flex justify-content-end">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="tableData.total"
                      :per-page="tableData.size"
                      first-number
                      last-number
                    ></b-pagination>
                  </div>

                  <div class="form-inline mt-2">
                    <span class="mr-2">Go to page:</span>
                    <b-form-input v-model="pageNo" class="in-width"></b-form-input>
                    <button class="btn btn-search ml-2" @click="filterPage">
                      Go
                    </button>
                  </div>

                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import wowDoctorMixin from "../../../mixins/ModuleJs/wow-doctors";

export default {
    data() {
      return {
        title: "List Wow Doctors",
        showInput: false,
        sortBy: "_id",
        sortDesc: true,
        items: [
          {
            text: "Home",
            href: "/",
          },
          {
            text: "List",
          },
        ],
      };
    },
    mixins: [wowDoctorMixin, MixinRequest],
    components: {
      Layout,
      PageHeader,
    },
  };
</script>
<style scoped>
.token-box{
  display: flex;
  align-items: center;
  gap: 8px;
}

.token-value{
  margin: 0;
  font-weight: 900;
  color: #d4af37; /* gold color */
  font-size: 16px;
  display: flex;
  align-items: center;
}

.coin{
  font-size: 18px;
  margin-right: 5px;
  animation: coinGlow 2s infinite alternate;
}

/* Golden glow animation */
@keyframes coinGlow {
  0% { transform: scale(1); filter: drop-shadow(0 0 2px gold); }
  100% { transform: scale(1.1); filter: drop-shadow(0 0 6px gold); }
}

.token-add-btn{
  border: none;
  background: #28a745;
  color: white;
  font-weight: bold;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 13px;
  cursor: pointer;
}

.token-add-btn:hover{
  background: #218838;
}
</style>